import { Box, Center, Flex, Icon, SimpleGrid, Text } from "@chakra-ui/react";
import React, {useEffect} from "react";
import { IoHomeOutline, IoPeopleOutline,IoSettingsOutline, IoPlay } from "react-icons/io5";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Home from "../Home";
import Config from "../paginas/Config";
import Notificacoes from "../paginas/Notificacoes";
import Reunioes from "../paginas/Reunioes";
import Votacao from "../paginas/Votacao";
import Header from "./Header";
import { onMessageListener, onLogout } from '../Firebase';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import { FaCheck } from 'react-icons/fa';
import api from "../servicos/Api";
import Homemulti from "../Homemulti";

const MySwal = withReactContent(Swal);

onMessageListener().then(payload => {
    console.log(payload);
    MySwal.fire({
        title: <p>{payload.notification.title}</p>,
        html:  <p>{payload.notification.body}</p>,
        imageUrl: payload.notification.image,
        imageWidth: 400,
        imageHeight: 200,
        confirmButtonText: <FaCheck />,
        confirmButtonColor: '#f48120',
        position : 'top',
        didOpen: () => {
          // MySwal.showLoading()
        },
      }).then(() => {
        // return MySwal.fire(<p>Shorthand works too</p>)
      }) 
}).catch(err => console.log('failed: ', err));

const LogadoContainer = (props) => {
    const navigate = useNavigate();

    const mostra_botao = async () => {
        const response = await api.post('login_app/botao_votacao_online');
        if(response.data.error === 0){
            const elemento = document.querySelector('.botaoLive');
            elemento.removeAttribute('hidden');
        }
    };

    const abre_live = async () => {
        const response = await api.post('login_app/live_conselho');
       console.log(response);
       if(response.data.hash != ''){
            window.open('https://conselho.gremio.net/index.php/login/aut_app/' + response.data.hash);
        
       }
    };

    useEffect(() => {
        mostra_botao();
    }, []);

    const logout = () => {
        onLogout();
        localStorage.setItem('ac', null);
        window.location.hash = '#/login';
    };

    return(
        <Box>
            <Header/>
            <Center>
            <Box mb='100px' w={{base: '100%', sm: '500px'}}>
            <Routes>
                <Route exact path='/' element={localStorage.getItem('ac') ? <Homemulti/> : <Navigate to="/login" />}/>
                <Route exact path='/reunioes' element={localStorage.getItem('ac') ? <Reunioes/> : <Navigate to="/login" />}/>
                <Route exact path='/notificacoes' element={localStorage.getItem('ac') ? <Notificacoes/> : <Navigate to="/login" />}/>
                <Route exact path='/notificacoes/:parametro' element={localStorage.getItem('ac') ? <Notificacoes/> : <Navigate to="/login" />}/>
                <Route exact path='/config' element={localStorage.getItem('ac') ? <Config logout={logout}/> : <Navigate to="/login" />}/>
                {/* <Route exact path='/votacao' element={localStorage.getItem('ac') ? <Votacao/> : <Navigate to="/login" />}/> */}
            </Routes>
            </Box>
            </Center>


            <SimpleGrid 
                className="botaoLive"
                columns={[1]} w='50px' h='50px' 
                hidden
                bg='#00a0e6' 
                direction='row' 
                justifyContent='space-evenly' 
                position='fixed' 
                bottom='100'
                right='2'
                p=''
                shadow='md'
                borderRadius='50px'
                >
                <Flex direction='row' color='white' justifyContent='center'textAlign='center' alignItems='center' cursor='pointer' onClick={() => abre_live()}>
                    <Icon boxSize='7' as={IoPlay}/>
                </Flex>
            </SimpleGrid>


            <SimpleGrid columns={[3]} w='100%' 
                bg='white' 
                direction='row' 
                justifyContent='space-evenly' 
                position='fixed' 
                bottom='0'
                p='4'
                shadow='md'
                borderTop='1px solid #dddddd'
                >
                <Flex direction='column' justifyContent='center' alignItems='center' cursor='pointer' onClick={() => navigate('/')}>
                    <Icon boxSize='5' as={IoHomeOutline}/>
                    <Text fontSize='sm'>Início</Text>
                </Flex>
                <Flex direction='column' justifyContent='center' alignItems='center' cursor='pointer' onClick={() => navigate('/reunioes')}>
                    <Icon boxSize='5' as={IoPeopleOutline}/>
                    <Text fontSize='sm'>Reuniões</Text>
                </Flex>
                <Flex direction='column' justifyContent='center' alignItems='center' cursor='pointer' onClick={() => navigate('/config')}>
                    <Icon boxSize='5' cursor='pointer' as={IoSettingsOutline}/>
                    <Text fontSize='sm'>Config</Text>
                </Flex>
            </SimpleGrid>
        </Box>
    );
};

export default LogadoContainer;